export default __webpack_public_path__ + "static/media/redCircle.649f068d.svg";